import { IS_LOADING_GETCATLIST2_CAT } from "../../ActionType/actionTypes";

export function isLoadingGetCatList2(param) {
    return (dispatch) => {
        dispatch({
            type: IS_LOADING_GETCATLIST2_CAT, 
            payload: {
                isLoadingGetCatList2: param
            }
        })
    }
}